<template>
    <div class="payment col-12 col-md-6 col-xl-3 wp_paymentSecured">
            <h5 data-test="footerHead2" id="footerHead2">{{$t(data.moduleHeading)}}</h5>
            <p>
              <img
                :src="$t(data.paymentPartnerImage)"
                :alt="$t(data.paymentPartnerAltText)"
                data-test="footerImg1"
                id="footerImg1"
              />
            </p>
            <ul>
              <li v-for="(partner,pKey) in data.paymentPartnerLogos" :key="pKey">
                <img
                  :src="$t(partner.image)"
                  :alt="$t(partner.altText)"
                />
              </li>
            </ul>
          </div>
</template>
<script>
export default {
	props: {
		data: {
			type: Object
		}
	}
}
</script>
